export default __webpack_public_path__ + "static/Glober-SemiBold-e2444849f53fc9a6ca348d6a59de57a7.otf";